import { render, staticRenderFns } from "./ComissaoTurno.vue?vue&type=template&id=cce0630c&scoped=true&"
import script from "./ComissaoTurno.vue?vue&type=script&lang=js&"
export * from "./ComissaoTurno.vue?vue&type=script&lang=js&"
import style0 from "./ComissaoTurno.vue?vue&type=style&index=0&id=cce0630c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cce0630c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VDataTable,VIcon,VTextField})
